/* eslint-disable react/no-danger */
import React, { useEffect, useState } from "react";

import classNames from "classnames";

const Banner = () => {
  const [hasWindow, setHasWindow] = useState(false);

  const bannerText =
    "<span class='promo-description'>🔥 <span class='bold'>Holiday Sale:</span> Up To <span class='bold'>40% OFF</span> + <span class='bold'>3 FREE Gifts!</span></span>";

  useEffect(() => {
    setHasWindow(true);
  }, []);

  return (
    <div className="banner-container">
      <div
        className={classNames("banner", {
          showed: !!bannerText && hasWindow,
        })}
      >
        <div
          className="banner-info"
          dangerouslySetInnerHTML={{
            __html: bannerText || "",
          }}
        />
      </div>
    </div>
  );
};

export default Banner;
